// egypt
export const locale = {
  lang: 'ar',
  data: {
    search: 'شاشة البحث',
    add: 'شاشة الاضافة',
    edit: 'تعديل بيانات',
    view: 'عرض بيانات',
    dashboard: 'الصفحة الرئيسية',
    TRANSLATOR: {
      SELECT: 'اختر لغتك',
    },
    ROUTE: {
      search: 'البحث',
      dashboard: 'الرئيسية',
      add: 'اضافة',
      edit: 'تعديل بيانات',
      view: 'عرض البيانات',
      labs: 'نتائج التحاليل',  
      radiologies:'نتائج الأشعة',
      profile:'الصفحة الشخصية' ,
      portal:'نظام المستخدم',
      appointments : 'مواعيدي' ,
      addappointment: 'حجز جديد',  
      specialties:'تخصصاتنا',
      doctors:'الطاقم الطبي',
      invoices:'فواتيري',
      approvals:'الموافقات الطبية',
      visits:'الزيارات',
      chat:'المحادثة',
      settings:'اعدادات',
      patientvisits:'زياراتي',
      switch:'تغير المستخدم',
      family:'العائلة',
      addnewmember: 'اضافة فرد جديد',
      birthrequests:'بلاغات الولادة',
      birthrequestsstaff:'بلاغات الولادة',
      sickleaverequests:'الاجازات المرضية',
      medicalReportrequests:' التقرير الطبي',
      payments:'المدفوعات المعلقة',
      complaintsandsuggestions:'الشكاوى والاقتراحات',
      offerrequests:'طلبات العروض',
      offersandpackages:' العروض والباقات',
      outsideTest:'العلامات الحيويه',
      news:'الاخبار',
      board:'مجلس الإدارة'
    },
    MENU: {
      LOGIN: 'تسجيل الدخول',
      AppTitle: 'بلسم للرعاية الطبية',
      NEW: 'جديد',
      ACTIONS: 'اجراءات',
      CREATE_POST: 'إنشاء منشور جديد',
      PAGES: 'الصفحات',
      FEATURES: 'مميزات',
      APPS: 'تطبيقات',
      DASHBOARD: 'الرئيسية',
      RAYSANDTESTS: 'الأشعة والتحاليل',
      HOME:' الرئيسية',
      CONTACTUS:'التواصل',
      ABOUTUS:'من نحن',
      ENTITIES:'شبكتنا الطبية ',
      HOPITALS:'مستشفياتنا ',
      MEDICALCENTERS : 'مراكزنا الطبية',
      ABOUTUSNew:'نبذة عنا',
      Board : 'مجلس الإدارة',
      BoardOfDirectors : 'الإدارة التنفيذية',
      DOCTORS:'الطاقم الطبي',
      SPECIALTIES:'تخصصاتنا',
      ADMINPANEL:'خدمات المستخدم',
      BLOG:'الاخبار',
      LABS:'نتائج التحاليل',
      RADIOLOGY:'نتائج الأشعة',
      PROFILE:' الصفحة الشخصية ',
      SOCIALMEDIA:' المركز الاعلامي',

      APPOINTMENTS:'مواعيدي',
      INVOICES:'فواتيري',
      APPROVALS:'الموافقات الطبية',
      VISITS :'الزيارات',
      CONGRATS:'بطاقات تهنئة',
      SETTINGS:'اعدادات',
      PATIENTVISITS:'زياراتي',
      FAMILY:'العائلة',
      SwitchFamily:'تغير المستخدم',
      DOCTORSLOTS:'مواعيد الطبيب',
      BIRTHREQUESTS:'بلاغات الولادة',
      SICKLEAVEREQUEST:'الاجازات المرضية',
      MEDICALREPORTREQUEST:' التقرير الطبي',
      PAYMENTS : 'المدفوعات المعلقة',
      complaintsandsuggestions:'الشكاوى والاقتراحات',
      COMPLAINTSANDSUGGESTIONS:'الشكاوى / الاقتراحات',
      offerrequest:'طلبات العروض',
      OUTSIDETEST:'العلامات الحيويه',
      SURVEY:'استطلاع',
      BlogDetails : 'تفاصيل الخبر',
      OFFERS:"كن شريك النجاح",
      CAREERS:"التوظيف",
      BOOKOFFER:"سجل بياناتك",
      BOARD:'مجلس الإدارة'
    },
    AUTH: {
      GENERAL: {
        OR: 'او',
        SUBMIT_BUTTON: 'حفظ',
        NO_ACCOUNT: 'ليس لديك حساب ؟',
        HAVE_ACCOUNT: ' لديك حساب ؟',
        SIGNUP_BUTTON: 'مستخدم جديد',
        FORGOT_BUTTON: 'نسيت كلمة المرور',
        BACK_BUTTON: 'العودة',
        PRIVACY: 'خصوصية',
        LEGAL: 'قانوني',
        CONTACT: 'اتصال',
        SIGNOUT: 'تسجيل خروج',
        FORGOTPASSWORD:'إعادة تعيين كلمة المرور',
        REMEMBERME:'تذكرني',
        CHANGEPASSWORD:'تغير كلمة المرور',
        DELETEACCOUNT :'حذف حسابي',
        DELETEACCOUNTPARA:'هل انت متأكد من حذف حسابك ؟',
        STAFF:'الموظفين'
      },
      LOGIN: {
        TITLE: 'تسجيل الدخول',
        STAFFTITLE: 'تسجيل الدخول',
        BUTTON: 'تسجيل الدخول',
      },
      FORGOT: {
        TITLE: 'كلمة سر منسية؟',
        DESC: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور الخاصة بك',
        SUCCESS: 'تم إعادة تعيين حسابك بنجاح.'
      },
      REGISTER: {
        TITLE: 'التسجيل',
        DESC: 'أدخل التفاصيل الخاصة بك لإنشاء حسابك',
        SUCCESS: 'تم تسجيل حسابك بنجاح.',
        TERMS:'البنود والقواعد',
        AGREE:'نعم اوافق علي'
      },
      INPUT: {
        EMAIL: 'بريد إلكتروني',
        PASSPORTNO:'رقم الهوية',
        PERSONALNO:'اسم المستخدم',
        FIRSTNAME: 'الاسم الاول',
        LASTNAME: 'الاسم الاخير',
        PASSWORD: 'كلمة المرور',
        PHONENUMBER:'رقم الجوال (5xxxx)',
        CONFIRM_PASSWORD: 'تأكيد كلمة المرور',
        AGE:'العمر',
        GENDER:'النوع',
        USERNAME: 'اسم المستخدم',
        NEWPASSWORD:'كلمة المرور الجديدة',
        OLDPASSWORD:'كلمة المرور الحالية',
        ENTERCODE:'ادخل الرمز',
        ENTERCODEPARA:'لقد أرسلنا رمزًا مكونًا من 6 أرقام إلى رقم هاتفك'
      },
      VALIDATION: {
        INVALID: '{{name}} غير صالح',
        REQUIRED: '{{name}} مطلوب',
        MIN_LENGTH: ' الحد الأدنى هو {{min}} حروف',
        MAX_LENGTH: ' الحد الاقصي هو {{max}} حروف',
        AGREEMENT_REQUIRED: 'مطلوب قبول الشروط والأحكام',
        NOT_FOUND: 'الذي تم طلبه {{name}} غير موجود',
        INVALID_LOGIN: 'تفاصيل تسجيل الدخول غير صحيحة',
        REQUIRED_FIELD: 'حقل مطلوب',
        MIN_LENGTH_FIELD: 'الحد الأدنى لطول الحقل:',
        MAX_LENGTH_FIELD: 'أقصى طول للحقل:',
        INVALID_FIELD: 'الحقل غير صالح',
        PLEASEENTER: 'من فضلك ادخل',
        ENTERDCORRECT: 'تم إدخاله بشكل صحيح ',
        NAMEARABIC: '{{name}} يجب ان يكون حروف عربية',
        NAMEENGLISH: '{{name}} يجب ان يكون حروف انجليزية',
        COMPAREDATES: '{{MaxDate}} يجب ان يكون اكبر من  {{MinDate}}',
        LessThanToday:'{{Date}} يجب ان يكون اقل من اليوم',
        GreaterThanOrEqualToday:'{{Date}} يجب ان يكون اكبر من او يساوي اليوم',
        COMPARENUMBERS:'{{Num2}} يجب ان يكون اكبر من  {{Num1}}',
        VALIDATEMOBILE: 'رقم هاتف غير صحيح',
        VALIDATEEMAIL: 'البريد الالكتروني غير صحيح',
        VALIDATIONIDENTITYNUMBER:'يجب ادخال رقم هوية صحيح',
        DIDNOTMATCH_FIELD:'كلمة المرور و تأكيد كلمة المرور غير متطابقين.',
        PASSWORDCONS:'كلمة المرور يجب ان تحتوي علي 6 حروف او اكثر باللغة الانجليزية بينهم حرف كبير',
        MOBILE_VALIDATION : 'يجب ادخال رقم جوال صحيح',
        NAME_VALIDATION:'يجب ادخال كلمات صحيحه',
        ID_VALIDATION:'يجب ادخال رقم الهوية صحيح'
      }
    },
    COMMON: {
      SUBMMIT:'ارسال',
      ACTIONS: 'اجراءات',
      SELECTED_RECORDS_COUNT: 'عدد السجلات المختارة: ',
      ALL: 'الكل',
      SUSPENDED: 'معلق',
      ACTIVE: 'مفعل',
      SEARCH: 'بحث',
      IN_ALL_FIELDS: 'في جميع الحقول',
      CLEAR: ' تفريغ الحقول',
      SEARCHRESULTS: 'نتائج البحث',
      BACK: 'رجوع',
      RESET: 'اعادة ضبط',
      EDIT: 'تعديل',
      DELETE: 'حذف',
      SAVE: 'حفظ',
      CANCEL: 'الغاء',
      BASICINFO: 'البيانات الاساسية',
      SELECT: 'اختر',
      ASSIGN: 'تحديد',
      OK: 'موافق',
      YES: 'نعم',
      NO: 'لا',
      TO: 'الي',
      OF: 'من',
      CLOSE: 'اغلاق',
      SHOWINGROWS: 'اظهار الصفوف',
      VIEW: "عرض البيانات",
      SAVING: 'يتم الحفظ',
      SAVED: 'تم الحفظ بنجاح',
      NEWSLETTER:'النشرة البريدية',
      NEWSLETTERPARA:'إشترك معنا لتصلك أخر المستجدات والعروض والمعلومات الطبية الهامة ',
      SUBSCRIBE:'اشتراك',
      CALL:'التواصل',
      SEARCHHERE:'ابحث هنا...',
      QUICKLINKS:'روابط سريعة' ,
      FEEDBACK:'رأيك يهمنا' ,
      DOWNLOAD:'تحميل',
      DELETEACCOUNT:'حذف حسابى',
      VIEWREPORT:'عرض التقرير',
      CONFIRM:'تأكيد',
      COMPELETE:'اكمال الطلب',
      DOWNLOADREPORT:'تحميل التقرير',
      PAY: 'دفع',
      ADDNEW:'اضافة جديد'

    },
    DASHBOARD: {
      GETAPPOINTMENT: 'احجز موعدك',
      LEARNMORE:'اعرف المزيد',
      SIGNOUT: 'تسجيل خروج',
    },
    CONTACTUS: {
      CONTACTUS:'التواصل',
      PHONE:'رقم الهاتف',
      POSTALCODE:'الرمز البريدي',
      EMAIL:'البريد الالكتروني',
      LOCATION:'الموقع',
      LOCATIONPARA:'   المملكة العربية السعودية، الرياض، حي الندوة، شارع آل راية  ',
      DROPYOURMESSAGE:'اترك رسالتك لأي معلومة أو سؤال.',
      NAME:'الاسم',
      SUBJECT:'موضوع الرسالة' ,
      MESSAGE:'نص الرسالة',
      SEND:'ارسال',
      EMERGENCYCALL:'المكالمات الطارئة',
    },
    ABOUTUS: {
      ABOUTUS:'من نحن',
      ABOUTHOSPITAL:' بلسم للرعاية الطبية',
      // ABOUTHOSPITALPARA:'مع تطور المجتمع أصبحت الرعاية الصحية عالية الجودة مطلبا أساسياً لجميع أفراده، وقد كان رهان حكومة خادم الحرمين الشريفين حفظه الله منصباً على تحقيق مجموعة من الأهداف الاستراتيجية التي تضمن تحسين نوعية حياة أفراد المجتمع وذلك بتوفير خدمات صحية ذات بعد تعزيزي علاجي أو وقائي أو تأهيلي يواكب جميع الفئات والأعمار، وضمان سهولة حصول كافة أفراد المجتمع لهذه الخدمات، وذلك بالاعتماد على معايير ومؤشرات تحقق مفاهيم الجودة الشاملة وتطوير خدمات الرعاية الصحية. وقد أصبح للقطاع الخاص دور أساسي في تحقيق هذه الاستراتيجية البعيدة، خصوصا بعد إطلاق رؤية 2030، وذلك انطلاقا من موقعه الموازي والتكميلي لدور الدولة في إنشاء وتمويل المشاريع الصحية من جهة، واستيعاب الطاقات البشرية على مستوى التشغيل والاستفادة من الخدمات الصحية عالية الجودة من جهة اخرى من هنا جاء دور مستشفى عناية العائلة ليقدم مثالا للمستشفيات التي التحقت بجدية ومسؤولية في هذا المشروع الضخم، ليشكل إضافة نوعية للبنية التحتية لمرافق الرعاية الصحية في منطقة الرياض، وليكون نموذجا للمستشفيات المستجيبة لمتطلبات الجودة المتعارف عليها محلياً وعالمياً.',
      EMPLOYEES:'زيارات المرضى السنوية',
      DOCTORSANDNURSE:'الموظفين ',
      CLINICKS:'العيادات الخارجية',
      PATIENTSBEDS:'الأسرة ' ,
      OURGOALS:'اهدافنا',
      PATIENTCARE:'رعاية المرضى',
      PATIENTCAREPARA:'إرضاء المرضى وعائلاتهم عبر تقديم خدمات تستجيب للمعايير الدولية للجودة.',
      BRANCHES:'الفروع',
      BRANCHESPARA:'توسيـع فروعنا على مستـوى مدن المملكة العربية السعودية ومنطقة الخليج.',
      DOCTORSCARE:'دعم الكوادر البشرية',
      DOCTORSCAREPARA:'دعم التكوين المستمر لكوادرنا البشرية، وتشجيعهم على التعلم الذاتي.',
      SOCIALMEDIA:'وسائل التواصل',
      SOCIALMEDIAPARA:'التطويـــر المتواصـل لآليـات العمـل ووسـائــل التواصــل مـع المرضى وعائلاتهم.',
      OURBLOGS:'الاخبار',
      READMORE:' المزيد'
    },
    LABS: {
      COMMON: {
        FILTER: 'البحث عن تحاليل',
        BY_NAME: 'حسب اسم التحليل',
      },
      GRID: {
        VISITDATE: 'تاريخ الزيارة',
        RESULTDATE:'تاريخ نتيجة التحليل',
        TECHNAME: 'اسم الطبيب',
        ORDERNUMBER: 'رقم الطلب',
      },
    },
    RADIOLOGY: {
      COMMON: {
        FILTER: 'البحث عن أشعة',
        BY_NAME: 'حسب اسم الأشعة',
      },
      GRID: {
        VISITDATE: 'تاريخ الزيارة',
        SERVICENAME: 'اسم الأشعة ',
        AUTHDOCNAME: 'اسم الطبيب',
        RESULTSTATUS:'حالة النتيجة'
      },
    },
    APPOINTMENTS: {
      COMMON: {
        FILTER: 'البحث عن حجز',
        BY_FROMDATE: 'من تاريخ',
        BY_TODATE: 'الي تاريخ',
      },
      GRID: {
        VISITDATE: 'تاريخ الزيارة',
        APPOINTMENTDATE: 'تاريخ الحجز',
        SPECIALTY:'التخصص',
        DOCTORNAME: 'اسم الطبيب',
        VISITTYPE:'نوع الزيارة',
        STATUS: 'الحالة',
        NEWAPPOINTMENT:'حجز موعد جديد',
        CLICK:'احجز',
        IsPayed:'تم الدفع'
      },
      ADD:{
        NEWAPPOINTMENT:'حجز موعد جديد',
        SPECIALTY:'اختر التخصص',
        DOCTOR:'اختر الطبيب',
        DATE:'اختر تاريخ الحجز',
        CHOOSEYOUDATE:'اختر الوقت المناسب لك',
        VALIDATEDATE:'يجب اختيار تاريخ مساويا لليوم او في المستقبل'
      },
      CONFIRMAPPOINTMENT:{
        TITLE:'تأكيد ميعاد حجز',
        MESSAGE:'هل انت متأكد من تأكيد الحجز ؟'
      },
      CANCELAPPOINTMENT:{
        TITLE:'الغاء ميعاد حجز',
        MESSAGE:'هل انت متأكد من الغاء الحجز ؟'
      },
      PAYAPPOINTMENT:{
        TITLE:'دفع رسوم',
        
      }
    },
    INVOICES: {
      COMMON: {
        FILTER: 'البحث عن فاتورة',
        BY_FROMDATE: ' من تاريخ',
        BY_TODATE: ' الي تاريخ',
      },
      GRID: {
        BILLDATE: 'تاريخ الدفع',
        SERVICENAME: 'اسم الخدمة ',
        PAYMENTTYPE: 'اسم الخدمة',
        SPECIALTY:'التخصص',
        ACTUALAMOUNT:'سعر الخدمة',
       TOTALAMOUNT:'إجمالي الفاتوره',
       AMOUNT:'المبلغ',
        PAIDAMOUNT:'تحمل المريض',
        DATE:'التاريخ'
      },
    },
    BIRTHREQUEST: {
      COMMON: {
        FILTER: 'البحث عن بلاغ ولادة',
        BY_FROMDATE: ' من تاريخ',
        BY_TODATE: ' الي تاريخ',
        BY_STATUS:'بالحالة',
        BY_MOTHERFILENO:'برقم ملف الام',
        BY_REQUESTNUMBER:'برقم الطلب',

      },
      GRID: {
        REQUESTDATE: 'تاريخ البلاغ',
        REQUESTNUMBER:'رقم الطلب',
        PATIENTCOMMENT:'ملاحظات صاحب التبليغ',
        HOSPITALCOMMENT:'ملاحظات المستشفى',
        BIRTHTYPE:'نوع الولادة',
        PERSONREPORTEDNAME:'اسم صاحب التبليغ',
        STATUS:'حالة البلاغ',
        FATHERID:'رقم هوية الاب',
        MOTHERID:'رقم هوية الام',
        BABYNAME:'اسم الطفل',
        MRN:'رقم ملف الام',
        Pendin:'قيد الانتظار',
        Completed:'مكتمل',
        InProgress:'تحت المراجعة',
        RequestSe7ty : 'رفع طلب لمنصة صحتي',
        RequestMedicalReport : 'طلب تقرير طبي'

      },
      ADD:{
        NEWBIRTHREQUEST:'طلب تبليغ ولادة جديد',
        VIEWBIRTHREQUEST:'عرض بيانات طلب تبليغ ولادة',
        VIEWSICKLEAVEREQUEST:'عرض بيانات طلب اجازاة مرضية',
        VIEWsuggestion:'عرض بيانات اقتراح',
        VIEWcomplaint:'عرض بيانات شكوى ',
        VIEWMEDICALREPORTREQUEST:'عرض بيانات طلب تقرير طبي',
        BABYINFORMATION:'بيانات الطفل',
        BABYNAME:'الاسم',
        BABYGENDER:'النوع',
        SINGLE:'فردي',
        TWIN:'تؤام',
        FATHERINFORMATION:'بيانات الاب',
        FIRSTNAME:'الاسم الاول',
        MIDDLENAME:'الاسم الثاني',
        LASTNAME:'الاسم الثالث',
        FAMILYNAME:'اسم العائلة',
        IDNO:'رقم الهوية',
        SERIAL:'النسخه',
        NATIONALITY:'الجنسية',
        IDTYPE:'نوع الاثبات',
        RELIGION:'الديانة',
        MOBILE:'رقم الجوال',
        MOTHERINFORMATION:'بيانات الام',
        RELATIVERELATION:'صلة القرابة',
        REPORTINGPERSONINFO:'بيانات التبليغ',
        REPORTINGMAME:'اسم من قام بالتبليغ',
        REPORTEDDATE:'التاريخ',
        REPORTINGIDNO:'رقم الاثبات',
        MOTHERFILENO:'رقم ملف الام',
        BABYFILENO:'رقم ملف الطفل',
        ATTACHMENT:'الملفات ',
        REQUIREDATTACHMENT:'الملفات المطلوبة',
        COMMENTS:'الملاحظات',
        InsertionDate:'التاريخ ',
        UserName:'اسم المستخدم',
        Comment:'الملاحظة',
        WriteYourComment:'اكتب ملاحظتك'


      },
    },
    OFFERS: {
      COMMON: {
        BY_FROMDATE: 'من تاريخ',
        BY_TODATE: 'الي تاريخ',
      },
      GRID: {
      
      },
      ADD:{
        NewOfferSection:'اضافة اخبار',
        OfferSectionNameEnglish:'عنوان الخبر بالانجليزية',
        OfferSectionNameArabic:'عنوان الخبر بالعربية',
        IsActive:'نشط',
        AddNewOffer:'اضافة اخبار',
        OfferNameEnglish:'التفاصيل بالانجليزية',
        OfferNameArabic:'  التفاصيل بالعربية',
        offerImage:'صورة الخبر',
        Remove:'حذف'
      },
    },
    Board: {
      COMMON: {
        BY_FROMDATE: 'من تاريخ',
        BY_TODATE: 'الي تاريخ',
        BY_Name: 'بالاسم',
      },
      ADD:{
        NewMember: 'عضو جديد',
        AddNewMember: 'إضافة عضو جديد',
        NameEn: 'الاسم (بالإنجليزية)',
        NameAr: 'الاسم (بالعربية)',
        TitleAr: 'المسمى الوظيفي (بالعربية)',
        TitleEn: 'المسمى الوظيفي (بالإنجليزية)',
        BioAr: 'نبذة (بالعربية)',
        BioEn: 'نبذة (بالإنجليزية)',
        IsActive: 'نشط',
        Order: 'الترتيب',
        Image: 'الصورة',
        BoardTeamType: 'نوع مجلس/فريق العمل',
        Board:'مجلس الادارة',
        BoardOfDirectors:'الادارة التنفذية'
      },
    },
  }
};
